<script setup>
import randomStr from '@/noc/str/random'
</script>
<template>
    <div class="relative" :class="isValidateError ? 'mb-6' : 'mb-3'">
        <input
            autosave="off"
            :disabled="disabled"
            :id="id"
            :type="type"
            :value="inputValue"
            @input="updateValue"
            v-model="inputValue" 
            :placeholder="placeholder"
            :autocomplete="autocomplete"
            class="relative w-full h-10 px-4 text-sm placeholder-transparent transition-all border rounded outline-none focus-visible:outline-none peer border-slate-200 text-slate-500 autofill:bg-white focus:border-emerald-500 focus:outline-none disabled:cursor-default disabled:bg-white disabled:text-slate-400"
            :class="getErrorValidate"/>
        <label
            :for="id"
            class="cursor-text bg-white peer-focus:cursor-default peer-autofill:-top-2 absolute left-2 -top-2 z-[1] px-2 text-xs text-slate-400 transition-all before:absolute before:top-0 before:left-0 before:z-[-1] before:block before:h-full before:w-full before:bg-white before:transition-all peer-placeholder-shown:top-2.5 peer-placeholder-shown:text-sm peer-required:after:text-pink-500 peer-required:after:content-['\00a0*'] peer-invalid:text-pink-500 peer-focus:-top-2 peer-focus:text-xs peer-focus:text-emerald-500 peer-invalid:peer-focus:text-pink-500 peer-disabled:cursor-default peer-disabled:text-slate-400 peer-disabled:before:bg-transparent">
            {{ label }}
        </label>
        <small
            v-if="isValidateError"
            class="absolute flex justify-between w-full px-4 py-1 text-xs transition text-pink-500">
            <span>{{ validateErrorMessage }}</span>
        </small>
    </div>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            default: ''
        },
        autocomplete: {
            type: String,
            default: 'off'
        },
        type: {
            type: String,
            default: 'text'
        },
        value: {
            type: String,
            default: '',
        },
        placeholder: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        rule: {
            type: Array,
            default: [],
        },
        name: {
            type: String,
            default: '',
        }
    },
    data() {
        return {
            id: randomStr(10),
            inputValue: this.value,
            isValidateError: false,
            validateErrorClass: '!border-pink-500 !text-pink-500 focus:!border-pink-500',
            validateErrorName: '',
            validateErrorMessage: ''
        }
    },
    computed: {
        getErrorValidate() {
            return this.isValidateError ? this.validateErrorClass : ''
        }
    },
    methods: {
        updateValue() {
            this.$emit('update:modelValue', this.inputValue);
        },
        handleRule() {
            for ( const rule of this.rule ) {
                if ( rule.includes(':') ) {
                    let ruleValue = rule.split(':')
                    if ( ruleValue[0] === 'max' ) {
                        if ( this.inputValue.length > parseInt(ruleValue[1]) ) {
                            this.isValidateError = true
                            this.validateErrorName = 'max'
                            this.validateErrorMessage = `Kolom ini tidak boleh lebih dari ${ruleValue[1]} karakter`
                            this.$parent.pushValidateError(this.name, true)
                            break
                        }

                        this.isValidateError = false
                        this.validateErrorName = ''
                        this.validateErrorMessage = ''
                        this.$parent.pushValidateError(this.name, false)
                    }
                } else if ( rule === 'required' ) {
                    if ( !this.inputValue ) {
                        this.isValidateError = true
                        this.validateErrorName = 'required'
                        this.validateErrorMessage = 'Kolom ini wajib diisi'
                        this.$parent.pushValidateError(this.name, true)
                        break
                    }

                    this.isValidateError = false
                    this.validateErrorName = ''
                    this.validateErrorMessage = ''
                    this.$parent.pushValidateError(this.name, false)
                } else if ( rule === 'string' ) {
                    if ( this.$el.querySelector('input').type !== 'text' ) {
                        console.error('ACT SCH - ERROR XMLi-01')
                        break
                    }

                    if ( typeof this.inputValue !== 'string' ) {
                        this.isValidateError = true
                        this.validateErrorName = 'required'
                        this.validateErrorMessage = 'Kolom ini '
                        break
                    }

                    this.isValidateError = false
                    this.validateErrorName = ''
                    this.validateErrorMessage = ''
                }
            }

        }
    },
    watch: {
        value(newValue) {
            this.inputValue = newValue
        },
        inputValue: function(value) {
            if ( this.rule.length ) {
                this.handleRule()
            }

            if ( this.name ) {
                this.$parent.registerToStage(this.name, value)
            }
        },
        '$parent.isReset': function(data) {
            if ( data ) {
                this.inputValue = ''
                setTimeout(() => {
                    this.isValidateError = false
                    this.validateErrorName = ''
                    this.validateErrorMessage = ''
                }, 200);
            }
        },
        '$parent.isSubmit': function(data) {
            if ( data && this.rule.length ) {
                this.handleRule()
            }
        }
    },
    mounted() {
        if ( this.name ) {
            this.$parent.registerToStage(this.name, this.value)
        }
    }
}
</script>